


















import {
  defineComponent,
  computed,
  provide,
  ref,
  onMounted
} from "@vue/composition-api";
import LoadingView from "@/components/Molecules/LoadingView/index.vue";
import ListTable from "@/components/Molecules/ListTable/index.vue";
import MenuDropdown from "@/components/Molecules/MenuDropdown/index.vue";
import OccHeading from "@/components/Atoms/OccHeading/index.vue";
import PageHeader from "@/components/Molecules/PageHeader/index.vue";
import Layout from "@/components/Atoms/Layout/index.vue";
import MailList from "./Organisms/MailList/index.vue";
import OccBreadcrumbs, {
  BreadcrumbRoute
} from "@/components/Atoms/OccBreadcrumbs/index.vue";
import { useJobEvent, JOB_EVENT_STORE_KEY } from "@/helpers/hooks/useJobEvent";
import { useGlobalState } from "@/helpers/hooks/useGlobalState";

export default defineComponent({
  components: {
    LoadingView,
    ListTable,
    MenuDropdown,
    OccHeading,
    PageHeader,
    Layout,
    MailList,
    OccBreadcrumbs
  },
  name: "JobEventSchedules",
  setup(_, { root }) {
    const eventId = Number(root.$route.params.eventId);

    provide(JOB_EVENT_STORE_KEY, useJobEvent({ eventId }));

    const { loading, editingJobEvent, refreshEditingJobEvent } = useGlobalState(
      JOB_EVENT_STORE_KEY
    );

    const isLoadingTemplates = ref(false);
    const loadMailTemplates = (isLoading: boolean) => {
      isLoadingTemplates.value = isLoading;
    };

    const selectedScheduleId = Number(root.$route.params.scheduleId);
    const selectedSchedule = computed(() => {
      return (editingJobEvent.value?.schedules || []).find(
        schedule =>
          schedule.id === selectedScheduleId ||
          schedule.schedule_id === selectedScheduleId
      );
    });
    const title = computed<string>(() => selectedSchedule.value?.title || "");

    const breadcrumbRoute = computed<BreadcrumbRoute[]>(() => [
      {
        label: "イベント一覧",
        to: {
          name: "JobEvents"
        }
      },
      {
        label: editingJobEvent.value?.title || "",
        to: {
          name: "JobEventSchedules"
        }
      },
      {
        label: "自動返信メールの編集",
        to: {
          name: ""
        },
        disabled: true
      }
    ]);

    onMounted(async () => {
      refreshEditingJobEvent();
    });

    return {
      eventId,
      loading,
      editingJobEvent,
      title,
      loadMailTemplates,
      isLoadingTemplates,
      selectedSchedule,
      breadcrumbRoute
    };
  }
});
